import React, { useEffect, useRef, useState } from "react";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { getCurrentDate } from "../../../../Utilitie";

const Monthly_Yealy_Comparison = ({ data, setSelectedDate }) => {
  const [date, setDate] = useState(getCurrentDate());
  const tableRef = useRef();

  useEffect(() => {
    setSelectedDate(date);
  }, [date]);
  /////////////////////////
  const monthSection =
    data && data.find((item) => item.filtered_by === "month");

  const mcurrent = monthSection?.current?.data || [];
  const mprevious = monthSection?.previous?.data || [];

  const previousmonthMap = {};
  mprevious.forEach((ire) => {
    previousmonthMap[ire.NAME] = ire;
  });
  //////////////////

  const yearSection =
    data && data.find((item) => item.filtered_by === "financial_year");

  const ycurrent = yearSection?.current?.data || [];
  const yprevious = yearSection?.previous?.data || [];

  const previousYearMap = {};
  yprevious.forEach((ire) => {
    previousYearMap[ire.NAME] = ire;
  });
  /////////////////////////

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white  p-1">
        <h5 className=" ms-2">IRE Monthly And Yearly Comparison </h5>
        <input
          className=""
          type="date"
          max={getCurrentDate()}
          value={date}
          onChange={(e) => {
            setDate(e.target.value);
          }}
        />
      </div>
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-hover newUiTable table-bordered table-striped "
          style={{ fontSize: "12px", fontWeight: "bold" }}
        >
          <thead
            className="thead-dark text-wrap"
            style={{
              maxWidth: "50px",
              textAlign: "center",

              verticalAlign: "middle",
            }}
          >
            <tr className="table-dark text-wrap">
              <th rowSpan={3}>Name</th>

              <th colSpan={9}>Monthly</th>
              <th colSpan={9}>Yearly</th>
            </tr>

            <tr className="table-dark ">
              <th className="text-wrap" colSpan={4}>
                {!data
                  ? `Previous`
                  : `${data[1].previous.start_date}/
                ${data[1].previous.end_date}`}
              </th>
              <th className="text-wrap" colSpan={4}>
                {!data
                  ? ` Current`
                  : ` ${data[1].current.start_date}/${data[1].current.end_date}`}
              </th>
              <th className="text-wrap" rowSpan={2}>
                Monthly Variation
              </th>

              <th className="text-wrap" colSpan={4}>
                {!data
                  ? `Previous`
                  : ` ${data[2].previous.start_date}/
                ${data[2].previous.end_date}`}
              </th>
              <th className="text-wrap" colSpan={4}>
                {!data
                  ? ` Current`
                  : ` ${data[2].current.start_date}/${data[2].current.end_date}`}
              </th>
              <th className="text-wrap" rowSpan={2}>
                Yearly Variation
              </th>
            </tr>

            <tr className="table-dark ">
              <th className="text-wrap">Monthly RECD</th>
              <th className="text-wrap">Monthly IRE</th>
              <th className="text-wrap">Monthly YDAYOB</th>
              <th className="text-wrap">Monthly Percentile</th>
              <th className="text-wrap">Monthly RECD</th>
              <th className="text-wrap">Monthly IRE</th>
              <th className="text-wrap">Monthly YDAYOB</th>
              <th className="text-wrap">Monthly Percentile </th>

              <th className="text-wrap">Yearly RECD</th>
              <th className="text-wrap">Yearly IRE</th>
              <th className="text-wrap">Yearly YDAYOB</th>
              <th className="text-wrap">Yearly Percentile</th>
              <th className="text-wrap">Yearly RECD</th>
              <th className="text-wrap">Yearly IRE</th>
              <th className="text-wrap">Yearly YDAYOB</th>
              <th className="text-wrap">Yearly Percentile</th>
            </tr>
          </thead>

          <tbody>
            {mcurrent.map((ire) => {
              const monthly = mcurrent.find((s) => s.NAME === ire.NAME) || {};
              const prevMonth = previousmonthMap[ire.NAME] || {};

              const yearly = ycurrent.find((s) => s.NAME === ire.NAME) || {};
              const prevYear = previousYearMap[ire.NAME] || {};
              const variation =
                monthly.Y_DAY_O_B_tot !== 0 && prevYear.PERCENTILE_tot !== 0
                  ? (
                      ((monthly.PERCENTILE_tot - prevMonth.PERCENTILE_tot) *
                        100) /
                      prevMonth.PERCENTILE_tot
                    ).toFixed(2)
                  : "-";
              const yearlyvariation =
                yearly.Y_DAY_O_B_tot !== 0 && prevYear.PERCENTILE_tot !== 0
                  ? (
                      ((yearly.PERCENTILE_tot - prevYear.PERCENTILE_tot) *
                        100) /
                      prevYear.PERCENTILE_tot
                    ).toFixed(2)
                  : "-";
              return (
                <tr key={ire.NAME} className=" text-center">
                  <td>{ire.NAME || "----"}</td>

                  {/* Monthly Data */}

                  <td>{prevMonth.RECD_tot || "-"}</td>
                  <td>{prevMonth.IRE_tot || "-"}</td>
                  <td>{prevMonth.Y_DAY_O_B_tot || "-"}</td>
                  <td>{prevMonth.PERCENTILE_tot || "-"}%</td>
                  <td>{monthly.RECD_tot || "-"}</td>
                  <td>{monthly.IRE_tot || "-"}</td>
                  <td>{monthly.Y_DAY_O_B_tot || "-"}</td>
                  <td>{monthly.PERCENTILE_tot || "-"}%</td>
                  <td>
                    <div
                      className="m-1 text-center p-1 "
                      style={{
                        borderRadius: "5px",
                        background:
                          variation < 0
                            ? " rgba(233, 75, 75, 0.9)"
                            : "rgba(88, 223, 61, 0.78)",
                        color: variation < 0 ? " white" : "black",
                      }}
                    >
                      {" "}
                      {variation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {variation === "Infinity" || variation === "NaN"
                        ? "--"
                        : variation}
                    </div>
                  </td>

                  {/* Yearly Data */}

                  <td>{prevYear.RECD_tot || "-"}</td>
                  <td>{prevYear.IRE_tot || "-"}</td>
                  <td>{prevYear.Y_DAY_O_B_tot || "-"}</td>
                  <td>{prevYear.PERCENTILE_tot || "-"}%</td>
                  <td>{yearly.RECD_tot || "-"}</td>
                  <td>{yearly.IRE_tot || "-"}</td>
                  <td>{yearly.Y_DAY_O_B_tot || "-"}</td>
                  <td>{yearly.PERCENTILE_tot || "-"}%</td>
                  <td>
                    <div
                      className="m-1 text-center p-1"
                      style={{
                        borderRadius: "5px",
                        background:
                          yearlyvariation < 0
                            ? " rgba(233, 75, 75, 0.9)"
                            : "rgba(88, 223, 61, 0.78)",
                        color: yearlyvariation < 0 ? " white" : "black",
                      }}
                    >
                      {" "}
                      {yearlyvariation > 0 ? (
                        <BsFillCaretUpFill />
                      ) : (
                        <BsFillCaretDownFill />
                      )}
                      {yearlyvariation === "Infinity" ||
                      yearlyvariation === "NaN"
                        ? "--"
                        : yearlyvariation}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!data ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`IRE Month data  - ${getCurrentDate()}`}
      />
    </div>
  );
};

export default Monthly_Yealy_Comparison;
